import type { SVGProps } from 'react';

/*
 * The mockup's ICON map, in the crs-mobile-app stroke style. Stroke, fill and
 * size come from the parent (.mob-tabbar__icon svg, .mob-icobtn svg,
 * .wtr-search svg); `Icon` only draws the path.
 */

type P = SVGProps<SVGSVGElement>;

function Svg({ children, ...rest }: P) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...rest}>
      {children}
    </svg>
  );
}

export const IconTables = (p: P) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M7 20v-4M17 20v-4" />
  </Svg>
);

export const IconOrders = (p: P) => (
  <Svg {...p}>
    <path d="M8 3h8a1 1 0 011 1v16l-5-3-5 3V4a1 1 0 011-1z" />
    <path d="M9.5 8h5M9.5 11.5h3" />
  </Svg>
);

export const IconKitchen = (p: P) => (
  <Svg {...p}>
    <path d="M5 3v7M8 3v7M6.5 10v11M16 3c-2 1.5-2.5 5-2.5 7.5 0 1.5 1 2.5 2.5 2.5v8M16 3c2 1.5 2.5 5 2.5 7.5 0 1.5-1 2.5-2.5 2.5" />
  </Svg>
);

/** A covered serving dish: the buffet board. */
export const IconBuffet = (p: P) => (
  <Svg {...p}>
    <path d="M3 17h18M4.5 17a7.5 7.5 0 0 1 15 0M12 9.5V8M10.5 8h3M5 20h14" />
  </Svg>
);

export const IconMore = (p: P) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.2" />
    <path d="M5 20c0-3.4 3.1-6 7-6s7 2.6 7 6" />
  </Svg>
);

export const IconSearch = (p: P) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.6-3.6" />
  </Svg>
);

export const IconArrowLeft = (p: P) => (
  <Svg {...p}>
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </Svg>
);

export const IconRefresh = (p: P) => (
  <Svg {...p}>
    <path d="M3 12a9 9 0 0115.5-6.2L21 8" />
    <path d="M21 3.5V8h-4.5" />
    <path d="M21 12a9 9 0 01-15.5 6.2L3 16" />
    <path d="M3 20.5V16h4.5" />
  </Svg>
);

export const IconUser = (p: P) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M4.5 20c0-3.6 3.4-6.4 7.5-6.4s7.5 2.8 7.5 6.4" />
  </Svg>
);

export const IconClose = (p: P) => (
  <Svg {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);

export const IconPrinter = (p: P) => (
  <Svg {...p}>
    <path d="M7 8V3h10v5" />
    <rect x="3" y="8" width="18" height="9" rx="2" />
    <path d="M7 14h10v7H7z" />
  </Svg>
);

export const ICON = {
  tables: IconTables,
  orders: IconOrders,
  kitchen: IconKitchen,
  more: IconMore,
  search: IconSearch,
  arrowLeft: IconArrowLeft,
  refresh: IconRefresh,
  user: IconUser,
  close: IconClose,
  printer: IconPrinter,
} as const;

export type IconName = keyof typeof ICON;

export function Icon({ name, ...rest }: { name: IconName } & P) {
  const C = ICON[name];
  return <C {...rest} />;
}
